import React, { Suspense } from 'react';
// import { makeStyles } from '@material-ui/styles';
import { ErrorBoundary } from '@sentry/react';
import DelayedFallback from './components/DelayedFallback';
import Router from '../Router';
import './style/main.scss';
import './style/onboarding.scss';
import ErrorRenderPage from './ErrorRenderPage';
import { useSelector } from 'react-redux';
// import desktopView from '../assets/images/deskopView_banner.png';
// import bannerImage from '../assets/images/onboardingLinkpromo.png';
// import { Button, CircularProgress } from '@material-ui/core';
// import { ONBOARDING_SEND_EMAIL } from '../config/api';
// import http from '../config/http';

// const useStyles = makeStyles((theme) => ({
//   mob_restrict_holder: {
//     display: 'none',
//     // [theme.breakpoints.down('sm')]: {
//     // display: 'flex',
//     backgroundColor: 'rgba(0, 0, 0, 0.7)',
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     height: '100%',
//     width: '100%',
//     opacity: 1,
//     transition: 'opacity 400ms ease-in',
//     overflowY: 'scroll',
//     justifyContent: 'center',
//     alignItems: 'center',
//     zIndex: '999999',
//     // },
//   },
//   mob_restrict_box: {
//     maxWidth: '450px',
//     width: '95%',
//     margin: '46px auto',
//     overflow: 'hidden',
//     transition: '0.6s',
//     bottom: 0,
//     background: '#fff',
//     padding: '0px',
//     textAlign: 'center',
//     borderRadius: '10px',
//     position: 'relative',
//   },
// }));

function FullWidthLayout() {
  // const classes = useStyles();
  const { user } = useSelector(({ auth }) => auth);
  // const [sendEmail, setSendEmail] = useState({ loading: false, text: 'Send me the Link', emailSent: false });
  const dialogOptions = {
    user: {
      email: user.email,
      name: user.name,
    },
  };

  // const sendLink = async () => {
  //   setSendEmail({ ...sendEmail, loading: true, emailSent: false });
  //   try {
  //     await http.post(ONBOARDING_SEND_EMAIL).then(() => {
  //       setSendEmail({ loading: false, text: 'Resend Link', emailSent: true });
  //     });
  //   } catch (error) {
  //     setSendEmail({ loading: false, text: 'Resend Link', emailSent: false });
  //   }
  // };

  return (
    <>
      <div>
        <div className="loading-holder">
          <ErrorBoundary fallback={ErrorRenderPage} showDialog dialogOptions={dialogOptions}>
            <Suspense fallback={<DelayedFallback />}>
              <Router />
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>

      {/* <div className={classes.mob_restrict_holder}>
        <div className={classes.mob_restrict_box}>
          <div>
            <img src={bannerImage} style={{ maxWidth: '100%' }} />
          </div>
          <div style={{ padding: '0px 20px', margin: '1rem 0' }}>
            <h4 style={{ lineHeight: 1.875, fontSize: '1.25rem', marginBottom: '0', marginTop: '0' }}>
              Complete the onboarding process
            </h4>
            <p
              style={{
                fontSize: '1rem',
                lineHeight: '1.5rem',
                opacity: 0.8,
                margin: '0',
              }}
            >
              We currently don't support this device, Click on the button below to send the login link to your Email and
              resume onboarding in Desktop.
            </p>
          </div>
          <div style={{ padding: '12px 30px 20px 30px', textAlign: 'center' }}>
            <Button
              disabled={sendEmail.loading}
              className="adPrimaryButtonAnimated"
              style={{ width: '70%', borderRadius: '8px' }}
              onClick={sendLink}
            >
              <div style={{ display: 'inline-block', verticalAlign: 'initial', fontSize: '16px' }}>
                <div style={{ display: 'inline-block', verticalAlign: 'initial', fontSize: '16px' }}>
                  {sendEmail.text}{' '}
                  {sendEmail.loading && <CircularProgress size={20} style={{ color: '#808080', marginLeft: '12px' }} />}
                </div>
              </div>
            </Button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {sendEmail.text === 'Resend Link' && (
              <>
                {!sendEmail.loading && sendEmail.emailSent ? (
                  <div style={{ color: 'green', textAlign: 'center' }}>
                    Email sent successfully to <span style={{ fontWeight: 500 }}>{user?.email}</span>
                  </div>
                ) : (
                  <div style={{ color: 'red', textAlign: 'center' }}>
                    Something went wrong.
                    <br />
                    Please try after sometime.
                  </div>
                )}
              </>
            )}
          </div>
          <div style={{ padding: '8px 30px 20px 30px', textAlign: 'center' }}>
            <img src={desktopView} style={{ width: '80%', maxWidth: '305px' }} />{' '}
          </div>
        </div>
      </div> */}
    </>
  );
}

export default FullWidthLayout;
